import React, { Fragment } from 'react'

import type { ProductType } from './ProductCardTypes'

interface ProductClusterHighlightsProps {
  product: ProductType
}

export default function ProductClusterHighlights({
  product,
}: ProductClusterHighlightsProps) {
  return (
    <>
      {product?.clusterHighlights?.map((item) => {
        if (item.id === '1951' || item.id === '1950') {
          return (
            <p
              className="tagProduct"
              style={{ fontWeight: '500' }}
              key={item.id}
            >
              {item.name}
            </p>
          )
        }

        return <Fragment key={item.id} />
      })}
    </>
  )
}
